<app-gallery-settings-customize-header
  title="Asset View"
  location="theme-asset-page-customize"
  (back)="back.emit()"
></app-gallery-settings-customize-header>

<app-gallery-settings-group>
  <app-rounded-hover-box [border]="true">
    <div class="theme-asset-page" [style.background-color]="theme().asset_page.background_color || 'black'">
      @if (theme().asset_page.ambient_mode) {
        <img class="ambience" [src]="'L48EV+00-qD*N*ozWCoz00~qD$-:' | blurHash" draggable="false" alt="" />
      }
      <img
        draggable="false"
        src="https://assets.picflow.com/2560x1707/2bb3050835/c0870e1f-91fb-441a-ac57-655f012c219d_horizontal.png/m/"
        class="theme-asset"
        alt="example image"
      />
    </div>
  </app-rounded-hover-box>
</app-gallery-settings-group>

<app-gallery-settings-group>
  <app-theme-asset-page-ambient-mode-item [gallery]="gallery()"></app-theme-asset-page-ambient-mode-item>
  <app-theme-asset-page-background-color-item [gallery]="gallery()"></app-theme-asset-page-background-color-item>
  <app-theme-asset-page-viewing-controls-item></app-theme-asset-page-viewing-controls-item>
</app-gallery-settings-group>
